'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getThreadId = undefined;

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _keyPaths = require('../constants/keyPaths');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getThreadId = exports.getThreadId = (0, _getIn2.default)(_keyPaths.THREAD_ID);


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/pubnub-message/operators/getThreadId.js
// module id = 884
// module chunks = 2 3